import Vue from 'vue';
import App from './App.vue';
import * as firebase from 'firebase';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { firestorePlugin } from 'vuefire'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";


Vue.config.productionTip = false;

Vue.use(firestorePlugin);

const configOptions = {
  apiKey: "AIzaSyD4O-QltHxcwjnqsoSP1q0Zzv02ro_zioU",
  authDomain: "vaccine-immunity.firebaseapp.com",
  databaseURL: "https://vaccine-immunity-default-rtdb.asia-southeast1.firebasedatabase.app",
  // databaseURL: "https://vaccine-immunity-default-rtdb-staging.asia-southeast1.firebasedatabase.app",
  // databaseURL: "http://localhost:9001/?ns=vaccine-immunity-default-rtdb",
  projectId: "vaccine-immunity",
  storageBucket: "vaccine-immunity.appspot.com",
  messagingSenderId: "104718380796",
  appId: "1:104718380796:web:37f3b6b326fe4688cd3179"
};

firebase.initializeApp(configOptions);
Vue.prototype.$firebase = firebase;

Sentry.init({
  Vue,
  dsn: "https://f95bc595b84d46b3a158567ea2db4067@o515671.ingest.sentry.io/5892007",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "https://https://vaccine-immunity-admin.web.app", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

let app;

firebase.auth().onAuthStateChanged(user => {
  store.dispatch('auth/fetchUser', user);
  if(!app) {
    new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
});
